// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4b4c7288","552":"20d7c65c","861":"73d9fc56"}[chunkId] + ".chunk.js";
};